import send from '../../utils/fetch'

const state = {
    management: [],
    managementStatistic: []
}

const actions = {
    async GET_MANAGEMENT({ commit, dispatch }, date) {
        try {
            const {data} = await send(`${global.$url.statistic.top_management}?direction=${date.direction}&start=${date.start}&end=${date.end}`, 'GET')
            // commit('SET_MANAGEMENT', data.result)
            return data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },

    DESTROY_MANAGEMENT({commit}) {
        commit('DESTROY_MANAGEMENT')
    }
}

const mutations = {
    DESTROY_MANAGEMENT(state) {
          state.management = []
          state.managementStatistic = []
    },

    SET_MANAGEMENT(state, data) {
        data.statistic = {}
        data.teamLeads = {}
        data.offerLeads = {}

        data.statistic['whole'] = {}
        data.statistic['whole'].all = 0
        data.statistic['whole'].fromHold = 0
        data.statistic['whole'].fromHold = 0
        data.statistic['whole'].deposit = 0
        data.statistic['whole'].hold = 0
        data.statistic['whole'].flag = ''

        for (const geo of data.geos) {
            data.statistic[geo.name] = {}
            data.statistic[geo.name].all = 0
            data.statistic[geo.name].fromHold = 0
            data.statistic[geo.name].fromHold = 0
            data.statistic[geo.name].deposit = 0
            data.statistic[geo.name].hold = data.holds[geo.name] ? data.holds[geo.name].length : 0
            data.statistic[geo.name].flag = geo.name
            data.statistic['whole'].hold += data.holds[geo.name] ?  data.holds[geo.name].length : 0

            if (data.geoLeads.hasOwnProperty(geo.name)) {
                for (let lead of data.geoLeads[geo.name]) {
                    data.statistic['whole'].all += 1
                    data.statistic[geo.name].all += 1

                    if (lead.created_at.split(' ')[0] !== lead.send_date.split(' ')[0]) {
                        data.statistic[geo.name].fromHold += 1
                        data.statistic['whole'].fromHold += 1
                    }

                    if (lead.first_action) {
                        data.statistic['whole'].deposit += 1
                        data.statistic[geo.name].deposit += 1
                    }

                    if (data.teamLeads.hasOwnProperty(data.filters.team_id[lead.team_id])) {
                        data.teamLeads[data.filters.team_id[lead.team_id]] += 1
                    } else {
                        data.teamLeads[data.filters.team_id[lead.team_id]] = 1
                    }

                    if (data.offerLeads.hasOwnProperty(lead.offer_name)) {
                        data.offerLeads[lead.offer_name] += 1
                    } else {
                        data.offerLeads[lead.offer_name] = 1
                    }
                }
            }
        }

        state.management = data
    },

}

const getters = {
    management: state => state.management
}

export default {
    state,
    actions,
    mutations,
    getters
}
